<template>
  <h1>Mudança de base de trabalho</h1>
  <DepartmentMembershipRequestManagementTable />
</template>

<script setup>
import DepartmentMembershipRequestManagementTable from '@/components/departments/membership/requests/DepartmentMembershipRequestManagementTable.vue';

</script>

<style scoped>

</style>